import { render, staticRenderFns } from "./trading.vue?vue&type=template&id=eb22134e&scoped=true&"
import script from "./trading.vue?vue&type=script&lang=js&"
export * from "./trading.vue?vue&type=script&lang=js&"
import style0 from "./trading.vue?vue&type=style&index=0&id=eb22134e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb22134e",
  null
  
)

export default component.exports